// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/antd/dist/reset.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mx-space-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.mx-space-evenly {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.mx-padded-content {
  padding: 20px;
}
.mx-ellipses {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mx-code-mirror-editor {
  border: 1px dashed #e3e3ff;
  height: calc(100% - 30px);
  max-height: 500px;
  overflow: auto;
}
.mx-code-mirror-editor .CodeMirror {
  height: 100%;
}
.mx-full-screen-height {
  height: calc(100vh - 110px);
  min-height: calc(100vh - 110px);
}
.mx-horz-gutter {
  background-repeat: no-repeat;
  background-position: 50%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  cursor: col-resize;
  background-color: #e4e4e4;
}
.mx-vert-gutter {
  background-repeat: no-repeat;
  background-position: 50%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  cursor: row-resize;
  background-color: #e4e4e4;
}
.mx-text-security {
  text-security: disc;
  -webkit-text-security: disc;
  -moz-text-security: disc;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@keyframes growBox {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
@keyframes slideBox {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
@-webkit-keyframes rotating {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
.color-scheme-0.color-1 {
  background-color: #1abcec;
}
.color-scheme-0.color-2 {
  background-color: #dd7379;
}
.color-scheme-0.color-3 {
  background-color: #ffce68;
}
.color-scheme-0.color-4 {
  background-color: #00a187;
}
.color-scheme-0.color-5 {
  background-color: #f588f8;
}
.color-scheme-0.color-6 {
  background-color: #a7cd77;
}
.color-scheme-0.color-7 {
  background-color: #e97f38;
}
.color-scheme-0.color-8 {
  background-color: #277bb4;
}
.color-scheme-1.color-1 {
  background-color: #9d73f8;
}
.color-scheme-1.color-2 {
  background-color: #77aa77;
}
.color-scheme-1.color-3 {
  background-color: #f6a181;
}
.color-scheme-1.color-4 {
  background-color: #11a3d7;
}
.color-scheme-1.color-5 {
  background-color: #f588f8;
}
.color-scheme-1.color-6 {
  background-color: #a7cd77;
}
.color-scheme-1.color-7 {
  background-color: #0a1ed0;
}
.color-scheme-1.color-8 {
  background-color: #277bb4;
}
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  color: #3f4142;
  background: #f0f2f5;
  font-family: 'Nunito', sans-serif;
  font-weight: 400;
  text-rendering: optimizeLegibility;
}
@media (max-width: 1200px) {
  html,
  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -moz-font-smoothing: antialiased;
    -o-font-smoothing: antialiased;
    font-smoothing: antialiased;
  }
}
.text-capitalize {
  text-transform: capitalize;
}
.hidden {
  display: none;
  visibility: hidden;
}
.ant-tooltip-inner {
  background-color: #343536;
}
.ant-tabs-content {
  height: 100%;
  overflow: scroll;
}
.ant-btn-primary > a {
  color: inherit;
}
.playground-layout-background {
  background: #ffffff !important;
}
.playground-layout-background .ant-menu {
  background: #ffffff;
}
.run-view-layout .playground-layout-background {
  min-height: calc(100vh - 92px);
  height: calc(100vh - 92px);
  position: sticky;
}
.kog-icon {
  font-size: 20px !important;
  color: #6f787e;
}
.kog-icon:hover,
.kog-icon.active {
  color: #096dd9 !important;
}
.ant-input::placeholder {
  color: #bfbfbf;
  user-select: none;
}
:placeholder-shown {
  text-overflow: ellipsis;
}
.display-flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.justify-space-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}
.font-12 {
  font-size: 12px;
}
.font-12 * {
  font-size: 12px;
}
.page-context-header {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #f0f2f5;
  padding: 10px;
  position: sticky;
  background: #fff;
  margin-bottom: 8px;
}
.ant-layout {
  background-color: #f0f2f5;
}
@media (min-width: 1440px) {
  .container {
    max-width: 1440px;
  }
}
.container {
  padding: 0px 35px;
}
.shimmer {
  color: grey;
  -webkit-mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right / 300% 100%;
  background-repeat: no-repeat;
  animation: shimmer 2.5s infinite;
}
.shimmer-finite {
  -webkit-mask: linear-gradient(-60deg, #000 30%, #0001, #000 70%) right / 300% 100%;
  background-repeat: no-repeat;
  animation: shimmer 6s;
}
@keyframes shimmer {
  100% {
    -webkit-mask-position: left;
  }
}
@keyframes slideInRight {
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.slideInRight {
  animation-name: slideInRight;
}
span[data-slate-node='text'] {
  display: block;
}
#slate-editor:focus-visible {
  box-shadow: none;
  outline: none;
}
[data-slate-placeholder='true'] {
  top: 5px !important;
  width: calc(100% - 30px) !important;
}
[data-slate-node='element'] {
  line-height: 1.45;
}
.low-opacity {
  opacity: 0.5;
}
.sentry-error-embed .form-submit .powered-by {
  display: none !important;
}
.sentry-error-embed .form-submit .close {
  border: 1px solid #888 !important;
  margin-right: 20px;
  padding: 10px !important;
}
.sentry-error-embed .form-submit {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}
`, "",{"version":3,"sources":["webpack://./src/css/mixins.less","webpack://./src/css/index.less","webpack://./src/css/animations.less","webpack://./src/css/colorschemes.less"],"names":[],"mappings":"AAgBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;ACdF;ADkBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AChBF;ADmBA;EACE,aAAA;ACjBF;ADoBA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AClBF;ADqBA;EACE,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;ACnBF;ADeA;EAOI,YAAA;ACnBJ;ADuBA;EACE,2BAAA;EACA,+BAAA;ACrBF;ADwBA;EACE,4BAAA;EACA,wBAAA;EACA,yDAAA;EACA,kBAAA;EACA,yBAAA;ACtBF;ADyBA;EACE,4BAAA;EACA,wBAAA;EACA,yDAAA;EACA,kBAAA;EACA,yBAAA;ACvBF;AD0BA;EACE,mBAAA;EACA,2BAAA;EACA,wBAAA;ACxBF;AD8BA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AC5BF;ACtDA;EACE;IACE,mBAAA;EDwDF;ECtDA;IACE,mBAAA;EDwDF;AACF;ACpDA;EACE;IAEE,QAAA;EDqDF;ECnDA;IACE,WAAA;EDqDF;AACF;AChDA;EACE;IACE,+BAAA;EDkDF;EChDA;IACE,iCAAA;EDkDF;AACF;AEzEE;EACE,yBAAA;AF2EJ;AEzEE;EACE,yBAAA;AF2EJ;AEzEE;EACE,yBAAA;AF2EJ;AEzEE;EACE,yBAAA;AF2EJ;AEzEE;EACE,yBAAA;AF2EJ;AEzEE;EACE,yBAAA;AF2EJ;AEzEE;EACE,yBAAA;AF2EJ;AEzEE;EACE,yBAAA;AF2EJ;AEtEE;EACE,yBAAA;AFwEJ;AEtEE;EACE,yBAAA;AFwEJ;AEtEE;EACE,yBAAA;AFwEJ;AEtEE;EACE,yBAAA;AFwEJ;AEtEE;EACE,yBAAA;AFwEJ;AEtEE;EACE,yBAAA;AFwEJ;AEtEE;EACE,yBAAA;AFwEJ;AEtEE;EACE,yBAAA;AFwEJ;AAxHA;;EAEE,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EAEA,iCAAA;EACA,gBAAA;EAKA,kCAAA;AAqHF;AAxHE;EAAA;;IDlBA,kCAAA;IAQA,mCAAA;IACA,gCAAA;IACA,8BAAA;IACA,2BAAA;ECwIA;AACF;AA3HA;EACE,0BAAA;AA6HF;AA1HA;EACE,aAAA;EACA,kBAAA;AA4HF;AAxHA;EACE,yBAAA;AA0HF;AAvHA;EACE,YAAA;EACA,gBAAA;AAyHF;AAtHA;EACE,cAAA;AAwHF;AArHA;EACE,8BAAA;AAuHF;AAxHA;EAII,mBAAA;AAuHJ;AAlHE;EACE,8BAAA;EACA,0BAAA;EACA,gBAAA;AAoHJ;AAhHA;EACE,0BAAA;EACA,cAAA;AAkHF;AAhHE;;EAEE,yBAAA;AAkHJ;AA7GA;EACE,cAAA;EACA,iBAAA;AA+GF;AA5GC;EACC,uBAAA;AA8GF;AA3GA;EACE,aAAA;AA6GF;AA3GA;EACE,uBAAA;AA6GF;AA3GA;EACE,8BAAA;AA6GF;AA3GA;EACE,mBAAA;AA6GF;AA3GA;EACE,eAAA;AA6GF;AA5GE;EACE,eAAA;AA8GJ;AA1GA;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA4GF;AAzGA;EACE,yBAAA;AA2GF;AAxGA;EACE;IACE,iBAAA;EA0GF;AACF;AAxGA;EACE,iBAAA;AA0GF;AAvGA;EACE,WAAA;EACA,kFAAA;EAEA,4BAAA;EACA,gCAAA;AAwGF;AArGA;EACE,kFAAA;EAEA,4BAAA;EACA,qBAAA;AAsGF;AAnGA;EACE;IACE,2BAAA;EAqGF;AACF;AAlGA;EACE;IACE,kCAAA;IACA,mBAAA;EAoGF;EAjGA;IACE,+BAAA;EAmGF;AACF;AAhGA;EACE,4BAAA;AAkGF;AA/FA;EACE,cAAA;AAiGF;AA9FA;EACE,gBAAA;EACA,aAAA;AAgGF;AA7FA;EACE,mBAAA;EACA,mCAAA;AA+FF;AA7FA;EACE,iBAAA;AA+FF;AA5FA;EACE,YAAA;AA8FF;AA1FA;EACE,wBAAA;AA4FF;AAzFA;EACE,iCAAA;EACA,kBAAA;EACA,wBAAA;AA2FF;AAzFA;EACE,aAAA;EACA,uBAAA;EACA,2BAAA;AA2FF","sourcesContent":[".mx-font-smoothing (@smoothing) when (@smoothing = antialiased) {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: @smoothing;\n  -moz-font-smoothing: @smoothing;\n  -o-font-smoothing: @smoothing;\n  font-smoothing: @smoothing;\n}\n\n.mx-font-smoothing (@smoothing: none) {\n  -webkit-font-smoothing: @smoothing;\n  -moz-font-smoothing: @smoothing;\n  -o-font-smoothing: @smoothing;\n  font-smoothing: @smoothing;\n}\n\n// dashboard style wrap\n.mx-space-wrap {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n// left/right align\n.mx-space-evenly {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.mx-padded-content {\n  padding: 20px;\n}\n\n.mx-ellipses {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mx-code-mirror-editor {\n  border: 1px dashed @border-color;\n  height: calc(~'100% - 30px');\n  max-height: 500px;\n  overflow: auto;\n\n  .CodeMirror {\n    height: 100%;\n  }\n}\n\n.mx-full-screen-height {\n  height: calc(100vh - 110px);\n  min-height: calc(100vh - 110px);\n}\n\n.mx-horz-gutter {\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');\n  cursor: col-resize;\n  background-color: @color-grey-4;\n}\n\n.mx-vert-gutter {\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');\n  cursor: row-resize;\n  background-color: @color-grey-4;\n}\n\n.mx-text-security {\n  text-security: disc;\n  -webkit-text-security: disc;\n  -moz-text-security: disc;\n}\n\n// Adding a new one - Please use prefix mx-\n// Thanks !\n\n.text-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n","// Main CSS file\n@import 'antd/dist/reset.css';\n@import 'variables.less';\n@import 'mixins.less';\n@import 'animations.less';\n@import 'colorschemes.less';\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  color: @baseFontColor;\n  background: @page-bg-color;\n\n  font-family: @baseFont;\n  font-weight: @fontWeightRegular;\n\n  @media (max-width: 1200px) {\n    .mx-font-smoothing(antialiased);\n  }\n  text-rendering: optimizeLegibility;\n}\n\n// Generic application wide classes\n.text-capitalize {\n  text-transform: capitalize;\n}\n\n.hidden {\n  display: none;\n  visibility: hidden;\n}\n\n// ANTD overrides\n.ant-tooltip-inner {\n  background-color: @tooltip-bg-color;\n}\n\n.ant-tabs-content {\n  height: 100%;\n  overflow: scroll;\n}\n\n.ant-btn-primary > a {\n  color: inherit;\n}\n\n.playground-layout-background {\n  background: @white !important;\n\n  .ant-menu {\n    background: @white;\n  }\n}\n\n.run-view-layout {\n  & .playground-layout-background {\n    min-height: calc(100vh - 92px);\n    height: calc(100vh - 92px);\n    position: sticky;\n  }\n}\n\n.kog-icon {\n  font-size: 20px !important;\n  color: @text-color-secondary;\n\n  &:hover,\n  &.active {\n    color: #096dd9 !important;\n  }\n}\n\n// Placeholder text\n.ant-input::placeholder {\n  color: #bfbfbf;\n  user-select: none; // https://github.com/ant-design/ant-design/pull/32639\n}\n\n&:placeholder-shown {\n  text-overflow: ellipsis;\n}\n\n.display-flex {\n  display: flex;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-space-between {\n  justify-content: space-between;\n}\n.align-center {\n  align-items: center;\n}\n.font-12 {\n  font-size: 12px;\n  & * {\n    font-size: 12px;\n  }\n}\n\n.page-context-header {\n  display: flex;\n  align-items: center;\n  border-bottom: 2px solid #f0f2f5;\n  padding: 10px;\n  position: sticky;\n  background: #fff;\n  margin-bottom: 8px;\n}\n\n.ant-layout {\n  background-color: @page-bg-color;\n}\n\n@media (min-width: 1440px) {\n  .container {\n    max-width: 1440px;\n  }\n}\n.container {\n  padding: 0px 35px;\n}\n\n.shimmer {\n  color: grey;\n  -webkit-mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300%\n    100%;\n  background-repeat: no-repeat;\n  animation: shimmer 2.5s infinite;\n}\n\n.shimmer-finite {\n  -webkit-mask: linear-gradient(-60deg, #000 30%, #0001, #000 70%) right/300%\n    100%;\n  background-repeat: no-repeat;\n  animation: shimmer 6s;\n}\n\n@keyframes shimmer {\n  100% {\n    -webkit-mask-position: left;\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translate3d(100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.slideInRight {\n  animation-name: slideInRight;\n}\n\nspan[data-slate-node='text'] {\n  display: block;\n}\n\n#slate-editor:focus-visible {\n  box-shadow: none;\n  outline: none;\n}\n\n[data-slate-placeholder='true'] {\n  top: 5px !important;\n  width: calc(100% - 30px) !important;\n}\n[data-slate-node='element'] {\n  line-height: 1.45;\n}\n\n.low-opacity {\n  opacity: 0.5;\n}\n\n// Sentry related css\n.sentry-error-embed .form-submit .powered-by {\n  display: none !important;\n}\n\n.sentry-error-embed .form-submit .close {\n  border: 1px solid #888 !important;\n  margin-right: 20px;\n  padding: 10px !important;\n}\n.sentry-error-embed .form-submit {\n  display: flex;\n  justify-content: center;\n  flex-direction: row-reverse;\n}\n","// Grow an element from 0 to fullsize\n@keyframes growBox {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n// Grow an element from 0 width to full width\n@keyframes slideBox {\n  from {\n    //transform: scale(0);\n    width: 0;\n  }\n  to {\n    width: 100%;\n    //transform: scale(1);\n  }\n}\n\n// Rotate an element\n@-webkit-keyframes rotating {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n","//\n// Copyright (C) - Kognitos, Inc. All rights reserved\n//\n// ColorSchemes - sets of visually contrasting colors used together\n//\n.color-scheme-0 {\n  &.color-1 {\n    background-color: #1abcec;\n  }\n  &.color-2 {\n    background-color: #dd7379;\n  }\n  &.color-3 {\n    background-color: #ffce68;\n  }\n  &.color-4 {\n    background-color: #00a187;\n  }\n  &.color-5 {\n    background-color: #f588f8;\n  }\n  &.color-6 {\n    background-color: #a7cd77;\n  }\n  &.color-7 {\n    background-color: #e97f38;\n  }\n  &.color-8 {\n    background-color: #277bb4;\n  }\n}\n\n.color-scheme-1 {\n  &.color-1 {\n    background-color: #9d73f8;\n  }\n  &.color-2 {\n    background-color: #77aa77;\n  }\n  &.color-3 {\n    background-color: #f6a181;\n  }\n  &.color-4 {\n    background-color: #11a3d7;\n  }\n  &.color-5 {\n    background-color: #f588f8;\n  }\n  &.color-6 {\n    background-color: #a7cd77;\n  }\n  &.color-7 {\n    background-color: #0a1ed0;\n  }\n  &.color-8 {\n    background-color: #277bb4;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
